import React, { useEffect, useState } from 'react';
import { Col, Container, Nav, Navbar, NavDropdown, Row, Button } from 'react-bootstrap';
import { routes } from '../../routes';
import { Link, useHistory } from 'react-router-dom';
import OurServicesController from '../../apis/controller/services.controller';
import Getin_touchmodal from '../../Views/Home/getin_touchmodal';

const Phonemenu = (props) => {
    let history = useHistory();
    const [show, setShow] = useState(false);
    const [servicesList, setServicesCategory] = useState();
    const [loader, setLoader] = useState(false);


    useEffect(() => {
        getServices()
        // window.addEventListener("scroll", () => {
        //     setScroll(window.scrollY > 50);
        // });
    }, []);

    const getServices = async () => {
        setLoader(true);
        let res = await new OurServicesController().servicesCategories();
        if (res && res.status) {
            setServicesCategory(res.categories);
        }
        setLoader(false);
    };

    const closeModel = async () => {
        setShow(false)
    };
    return (
        <>
            <div className="phoneside d-lg-none d-block">
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0'>
                            <div className='head text-center'>
                                <h6>Techcurizer</h6>
                                <div className='icon-Back'>
                                    <a 
                                onClick={() => {
                                    history.goBack();
                                }}><i className="fas fa-long-arrow-left"></i></a>
                                </div>
                            </div>
                            {servicesList && <div className='profile ps-3'>
                            <Navbar collapseOnSelect >
                                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                    <Navbar.Collapse id="responsive-navbar-nav">
                                        <Nav className="mr-auto left_area">
                                            <Nav.Item>
                                                <Link to={routes.index}>Home</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.about}>About</Link>
                                            </Nav.Item>
                                            <NavDropdown title="Services" id="collasible-nav-dropdown">
                                            {servicesList.map((item, index) => (
                                                <NavDropdown key={index} className='sub' title={item.title} id={index}>
                                                    <> {item.services.map((item, index) => (
                                                        <NavDropdown.Item key={index} href={`/service/${item.slug}`}>{item.title}</NavDropdown.Item>
                                                    ))}</>
                                                </NavDropdown>
                                            ))}
                                        </NavDropdown>
                                            <Nav.Item>
                                                <Link to={routes.product}>Products</Link>
                                            </Nav.Item> 
                                            <Nav.Item>
                                                <Link to="#">Technologies</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.packages}>Packages</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.verticals}>Verticals</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.hire}>Hire Resources</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.career}>Careers</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.contact}>Contact Us</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                            <Button variant="outline-primary" onClick={() => setShow(true)}>Quick Contact</Button>
                                            </Nav.Item>
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>
                            </div>}
                        </div>
                    </div>
                </div>
            </div><Getin_touchmodal show={show} closemodel={closeModel} />
        </>
    )
}



export default (Phonemenu);
